'use client';

// Side-effect module: importing it loads the default theme's CSS chunk. It is pulled in
// dynamically by the form's `index.tsx` only when this variant is selected, so a page
// never ships the stylesheet of a variant it does not use.
import './style.css';

export default function DefaultTheme(): null {
  return null;
}
